import throttle from '../throttle';
const KEY = 'hero_inactivity_time';
class InactivityTimer {
    constructor(props) {
        this.updateExpiryTime = throttle(() => {
            localStorage.setItem(KEY, (Date.now() + this.timeout * 1000).toString());
            this.onWarningExit && this.onWarningExit();
            this.warningTriggered = false;
        }, 1000);
        this.timeout = props.timeout;
        this.onTimeout = props.onTimeout;
        this.warningTimeout = props.warningTimeout;
        this.onWarning = props.onWarning;
        this.onWarningExit = props.onWarningExit;
        this.warningTriggered = false;
        this.eventHandler = this.updateExpiryTime.bind(this);
        this.tracker();
        this.startInterval();
    }
    startInterval() {
        this.updateExpiryTime();
        this.interval = setInterval(() => {
            const expiryTime = parseInt(localStorage.getItem(KEY) || '0', 10);
            if (expiryTime < Date.now() && this.onTimeout) {
                this.onTimeout();
                this.cleanUp();
                return;
            }
            if (!this.warningTriggered &&
                expiryTime - (this.timeout - this.warningTimeout) * 1000 < Date.now() &&
                this.onWarning) {
                this.onWarning();
                this.warningTriggered = true;
            }
        }, 1000);
    }
    tracker() {
        window.addEventListener('click', this.eventHandler);
        window.addEventListener('mousemove', this.eventHandler);
        window.addEventListener('scroll', this.eventHandler);
        window.addEventListener('keydown', this.eventHandler);
    }
    cleanUp() {
        localStorage.removeItem(KEY);
        clearInterval(this.interval);
        window.removeEventListener('click', this.eventHandler);
        window.removeEventListener('mousemove', this.eventHandler);
        window.removeEventListener('scroll', this.eventHandler);
        window.removeEventListener('keydown', this.eventHandler);
    }
}
export default InactivityTimer;
//# sourceMappingURL=index.js.map